<hr>
<div class="row">
    <ng-container *ngIf="transferDirection === 'outgoing' || transactionType != 'ach'">
        <div class="column">
            <mm-condensed-label-group id="condensed_fedTax" class="loa loaSubmitDetails" data-loafieldname="{{pdfLabels.fedTax}}" [title]="labels.federalTax" [data]="federalTax"></mm-condensed-label-group>
        </div>
        <div class="column" *ngIf="!isOneTimeTotalDist && !is401kToAccount">
            <mm-condensed-label-group id="condensed_fedTaxAmount" data-testid="condensed_fedTaxAmount" [title]="labels.federalTaxAmount" [data]="federalTaxAmount"></mm-condensed-label-group>
        </div>
        <div class="column">
            <mm-condensed-label-group id="condensed_stateTax" class="loa loaSubmitDetails" data-loafieldname="{{pdfLabels.stateTax}}" [title]="stateTaxLabel" [data]="stateTax"></mm-condensed-label-group>
        </div>
        <div class="column" *ngIf="!isOneTimeTotalDist && !is401kToAccount">
            <mm-condensed-label-group id="condensed_stateTaxAmount" data-testid="condensed_stateTaxAmount" [title]="labels.stateTaxAmount" [data]="stateTaxAmount"></mm-condensed-label-group>
        </div>
    </ng-container>
    <div class="column" *ngIf="!!distributionReason">
        <mm-condensed-label-group id="condensed_distributionReason" class="loa loaSubmitDetails" data-loafieldname="{{pdfLabels.distributionReason}}" data-testid="distribution-reason-label" [title]="labels.distributionReason" [data]="distributionReason"></mm-condensed-label-group>
    </div>
    <div class="column" *ngIf="!!contributionReason">
        <mm-condensed-label-group id="condensed_contributionReason" data-testid="contribution-reason-label" [title]="labels.contributionReason" [data]="contributionReason"></mm-condensed-label-group>
    </div>
</div>
<div id="condensed_taxMessageOne" class="tax-message" >{{taxCopyParagraphOne}}</div>
<div id="condensed_taxMessageTwo" class="tax-message" >{{taxCopyParagraphTwo}}</div>
